/**
 * Auth Types and Constants
 * Centralized type definitions and constants for authentication
 */

/**
 * Auth state types
 */
export const AuthState = {
  IDLE: 'idle',
  LOADING: 'loading',
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
  ERROR: 'error',
};

/**
 * Token refresh status
 */
export const TokenRefreshStatus = {
  IDLE: 'idle',
  REFRESHING: 'refreshing',
  SUCCESS: 'success',
  FAILED: 'failed',
};

/**
 * Auth error codes
 */
export const AuthErrorCode = {
  UNAUTHORIZED: 'UNAUTHORIZED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  TOKEN_INVALID: 'TOKEN_INVALID',
  NETWORK_ERROR: 'NETWORK_ERROR',
  LOGIN_FAILED: 'LOGIN_FAILED',
  REFRESH_FAILED: 'REFRESH_FAILED',
  UNKNOWN: 'UNKNOWN',
};

/**
 * Create auth error
 * @param {string} code - Error code
 * @param {string} message - Error message
 * @param {Object} details - Additional error details
 * @returns {Error} Auth error object
 */
export const createAuthError = (code, message, details = {}) => {
  const error = new Error(message);
  error.code = code;
  error.details = details;
  error.isAuthError = true;
  return error;
};

/**
 * Check if error is auth-related
 * @param {Error} error - Error object
 * @returns {boolean} True if auth error
 */
export const isAuthError = (error) => {
  return (
    error?.isAuthError ||
    error?.requiresLogin ||
    error?.code === AuthErrorCode.UNAUTHORIZED ||
    error?.code === AuthErrorCode.TOKEN_EXPIRED ||
    error?.code === AuthErrorCode.TOKEN_INVALID ||
    error?.response?.status === 401
  );
};

/**
 * Get error message from error object
 * @param {Error} error - Error object
 * @returns {string} Error message
 */
export const getAuthErrorMessage = (error) => {
  if (error?.message) {
    return error.message;
  }
  
  if (error?.response?.data?.message) {
    const message = error.response.data.message;
    return Array.isArray(message) ? message[0] : message;
  }
  
  if (error?.code === AuthErrorCode.TOKEN_EXPIRED) {
    return 'Sesi telah berakhir. Silakan login kembali.';
  }
  
  if (error?.code === AuthErrorCode.UNAUTHORIZED) {
    return 'Silakan login terlebih dahulu untuk mengakses.';
  }
  
  return 'Terjadi kesalahan saat autentikasi.';
};








